export default {
  "areaChart": {
    "config": {
      "changed": true,
      "title": "Area Chart",
      "navSection": "cart",
      "icon": "areaChart",
      "image": "areaChart.png"
    },
    "items": {
      "general": {
        "responsive": true
      },
      "legend": {
        "style": "MarkersOnly",
        "circleDefaultIcon": true,
        "show": false,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#605E5C",
        "fontFamily": "Segoe UI",
        "fontSize": 8
      },
      "categoryAxis": {
        "position": "Left",
        "show": true,
        "axisType": "Continuous",
        "axisScale": "linear",
        "labelColor": "#605E5C",
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "preferredCategoryWidth": 20,
        "maxMarginFactor": 25,
        "innerPadding": 20,
        "concatenateLabels": true,
        "showAxisTitle": false,
        "axisStyle": "showOnlyTitle",
        "titleColor": "#020f47",
        "titleText": "",
        "titleFontSize": 8,
        "titleFontFamily": "Segoe UI",
        "gridlineShow": false,
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "valueAxis": {
        "position": "Left",
        "gridlineShow": true,
        "show": true,
        "axisScale": "linear",
        "invertAxis": false,
        "labelColor": "#605E5C",
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": "#020f47",
        "titleText": "",
        "titleFontSize": 8,
        "titleFontFamily": "Segoe UI",
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "y2Axis": {
        "show": false,
        "secScaleType": "Linear",
        "secLabelColor": "#605E5C",
        "secFontSize": 8,
        "secFontFamily": "Segoe UI",
        "secLabelDisplayUnits": "0",
        "secLabelPrecision": 0,
        "secShowAxisTitle": true,
        "secTitleStyle": "showTitleOnly",
        "secTitleColor": "#020f47",
        "secTitleText": "",
        "secTitleFontSize": 8,
        "secTitleFontFamily": "Segoe UI"
      },
      "zoom": {
        "show": false,
        "showOnCategoryAxis": true,
        "showOnValueAxis": true,
        "showLabels": false,
        "showTooltip": false
      },
      "dataPoint": {
        "transparency": 60,
        "showAllDataPoints": false,
        "fill": "#5e78e5"
      },
      "labels": {
        "color": "#605E5C",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "preserveWhitespace": true,
        "show": false,
        "labelOrientation": "horizontal",
        "labelPosition": "Auto",
        "labelOverflow": false,
        "labelDensity": 50,
        "backgroundColor": "#e6e6e6"
      },
      "lineStyles": {
        "shadeArea": null,
        "strokeWidth": 3,
        "strokeLineJoin": "round",
        "lineStyle": "solid",
        "showMarker": false,
        "markerShape": "circle",
        "markerSize": 5,
        "markerColor": "#FFFFFF",
        "stepped": false
      },
      "plotArea": {
        "transparency": 100
      },
      "title": {
        "show": false,
        "text": "",
        "titleWrap": true,
        "fontColor": "#020f47",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 10,
        "fontFamily": "Segoe UI Light"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#000000",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": true,
        "type": "Report page",
        "titleFontColor": "#020f47",
        "valueFontColor": "#020f47",
        "actionFontColor": "#020f47",
        "fontSize": 10,
        "fontFamily": "Segoe UI",
        "background": "#e6e6e6",
        "transparency": 5,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#FFFFFF",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 30,
        "foreground": "#98918b",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  },
  "lineChart": {
    "config": {
      "changed": true,
      "title": "Line Chart",
      "navSection": "cart",
      "icon": "lineChart",
      "image": "lineChart.png"
    },
    "items": {
      "general": {
        "responsive": false
      },
      "legend": {
        "style": "MarkersOnly",
        "circleDefaultIcon": true,
        "show": false,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#605E5C",
        "fontFamily": "Segoe UI",
        "fontSize": 8
      },
      "categoryAxis": {
        "position": "Left",
        "show": true,
        "axisType": "Continuous",
        "axisScale": "linear",
        "labelColor": "#605E5C",
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "preferredCategoryWidth": 20,
        "maxMarginFactor": 25,
        "innerPadding": 20,
        "concatenateLabels": true,
        "showAxisTitle": false,
        "axisStyle": "showOnlyTitle",
        "titleColor": "#020f47",
        "titleText": "",
        "titleFontSize": 8,
        "titleFontFamily": "Segoe UI",
        "gridlineShow": false,
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "valueAxis": {
        "position": "Left",
        "gridlineShow": false,
        "show": true,
        "axisScale": "linear",
        "invertAxis": false,
        "labelColor": "#605E5C",
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "showAxisTitle": false,
        "axisStyle": "showTitleOnly",
        "titleColor": "#020f47",
        "titleText": "",
        "titleFontSize": 8,
        "titleFontFamily": "Segoe UI",
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "y2Axis": {
        "show": false,
        "secScaleType": "Linear",
        "secLabelColor": "#605E5C",
        "secFontSize": 8,
        "secFontFamily": "Segoe UI",
        "secLabelDisplayUnits": "0",
        "secLabelPrecision": 0,
        "secShowAxisTitle": false,
        "secTitleStyle": "showTitleOnly",
        "secTitleColor": "#020f47",
        "secTitleText": "",
        "secTitleFontSize": 8,
        "secTitleFontFamily": "Segoe UI"
      },
      "zoom": {
        "show": false,
        "showOnCategoryAxis": true,
        "showOnValueAxis": true,
        "showLabels": false,
        "showTooltip": false
      },
      "dataPoint": {
        "transparency": null,
        "showAllDataPoints": false,
        "fill": "#5e78e5"
      },
      "labels": {
        "color": "#605E5C",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 8,
        "fontFamily": "Segoe UI",
        "preserveWhitespace": true,
        "show": false,
        "labelOrientation": "horizontal",
        "labelPosition": "Auto",
        "labelOverflow": false,
        "labelDensity": 50,
        "backgroundColor": "#252423"
      },
      "lineStyles": {
        "shadeArea": null,
        "strokeWidth": 3,
        "strokeLineJoin": "round",
        "lineStyle": "solid",
        "showMarker": false,
        "markerShape": "circle",
        "markerSize": 5,
        "markerColor": "#FFFFFF",
        "stepped": false
      },
      "plotArea": {
        "transparency": 100
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": true,
        "fontColor": "#020f47",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 10,
        "fontFamily": "Segoe UI Light"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#000000",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": true,
        "type": "Report page",
        "titleFontColor": "#020f47",
        "valueFontColor": "#020f47",
        "actionFontColor": "#020f47",
        "fontSize": 10,
        "fontFamily": "Segoe UI",
        "background": "#e6e6e6",
        "transparency": 5,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#FFFFFF",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 30,
        "foreground": "#98918b",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  },
  "lineClusteredColumnComboChart": {
    "config": {
      "changed": true,
      "title": "Line and Clustered Column Chart",
      "navSection": "cart",
      "icon": "lineClusteredColumnComboChart",
      "image": "lineClusteredColumnComboChart.png"
    },
    "items": {
      "general": {
        "responsive": false
      },
      "legend": {
        "style": "MarkersOnly",
        "circleDefaultIcon": true,
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#605E5C",
        "fontFamily": "Segoe UI",
        "fontSize": 9
      },
      "categoryAxis": {
        "position": null,
        "show": true,
        "axisType": "Continuous",
        "axisScale": "linear",
        "labelColor": "#605E5C",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "preferredCategoryWidth": 20,
        "maxMarginFactor": 25,
        "innerPadding": 20,
        "concatenateLabels": true,
        "showAxisTitle": false,
        "axisStyle": "showOnlyTitle",
        "titleColor": "#252423",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "DIN",
        "gridlineShow": false,
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "valueAxis": {
        "position": "Left",
        "gridlineShow": true,
        "show": true,
        "axisScale": "linear",
        "invertAxis": false,
        "labelColor": "#605E5C",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "showAxisTitle": false,
        "axisStyle": "showTitleOnly",
        "titleColor": "#252423",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "DIN",
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "zoom": {
        "show": false,
        "showOnCategoryAxis": true,
        "showOnValueAxis": true,
        "showLabels": false,
        "showTooltip": false
      },
      "dataPoint": {
        "transparency": null,
        "showAllDataPoints": false,
        "fill": "#118DFF"
      },
      "labels": {
        "color": "#605E5C",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "preserveWhitespace": true,
        "show": false,
        "labelOrientation": "horizontal",
        "labelPosition": "Auto",
        "labelOverflow": false,
        "labelDensity": 50,
        "backgroundColor": "#252423"
      },
      "lineStyles": {
        "shadeArea": false,
        "strokeWidth": 3,
        "strokeLineJoin": "round",
        "lineStyle": "solid",
        "showMarker": false,
        "markerShape": "circle",
        "markerSize": 5,
        "markerColor": "#FFFFFF",
        "stepped": false
      },
      "plotArea": {
        "transparency": 0
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": true,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 14,
        "fontFamily": "DIN"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#000000",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "type": "Report page",
        "titleFontColor": "#020f47",
        "valueFontColor": "#020f47",
        "actionFontColor": "#020f47",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#e6e6e6",
        "transparency": 5,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#020f47",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 60,
        "foreground": "#efefef",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  },
  "lineStackedColumnComboChart": {
    "config": {
      "changed": true,
      "title": "Line and Stacked Column Chart",
      "navSection": "cart",
      "icon": "lineStackedColumnComboChart",
      "image": "lineStackedColumnComboChart.png"
    },
    "items": {
      "general": {
        "responsive": false
      },
      "legend": {
        "style": "MarkersOnly",
        "circleDefaultIcon": true,
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#605E5C",
        "fontFamily": "Segoe UI",
        "fontSize": 9
      },
      "categoryAxis": {
        "position": null,
        "show": true,
        "axisType": "Continuous",
        "axisScale": "linear",
        "labelColor": "#605E5C",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "preferredCategoryWidth": 20,
        "maxMarginFactor": 25,
        "innerPadding": 20,
        "concatenateLabels": true,
        "showAxisTitle": false,
        "axisStyle": "showOnlyTitle",
        "titleColor": "#252423",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "DIN",
        "gridlineShow": false,
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "valueAxis": {
        "position": "Left",
        "gridlineShow": true,
        "show": true,
        "axisScale": "linear",
        "invertAxis": false,
        "labelColor": "#605E5C",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "showAxisTitle": false,
        "axisStyle": "showTitleOnly",
        "titleColor": "#252423",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "DIN",
        "gridlineColor": "#C8C6C4",
        "gridlineThickness": 1,
        "gridlineStyle": "dotted"
      },
      "zoom": {
        "show": false,
        "showOnCategoryAxis": true,
        "showOnValueAxis": true,
        "showLabels": false,
        "showTooltip": false
      },
      "dataPoint": {
        "transparency": null,
        "showAllDataPoints": false,
        "fill": "#118DFF"
      },
      "labels": {
        "color": "#605E5C",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "preserveWhitespace": true,
        "show": false,
        "labelOrientation": "horizontal",
        "labelPosition": "Auto",
        "labelOverflow": false,
        "labelDensity": 50,
        "backgroundColor": "#252423"
      },
      "totals": {
        "show": false,
        "color": "#605E5C",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "backgroundColor": "#252423",
        "showPositiveAndNegative": false
      },
      "lineStyles": {
        "shadeArea": false,
        "strokeWidth": 3,
        "strokeLineJoin": "round",
        "lineStyle": "solid",
        "showMarker": false,
        "markerShape": "circle",
        "markerSize": 5,
        "markerColor": "#FFFFFF",
        "stepped": false
      },
      "plotArea": {
        "transparency": 0
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": true,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 14,
        "fontFamily": "DIN"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#000000",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "type": "Report page",
        "titleFontColor": "#020f47",
        "valueFontColor": "#020f47",
        "actionFontColor": "#020f47",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#e6e6e6",
        "transparency": 5,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#020f47",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 60,
        "foreground": "#efefef",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  },
  "ribbonChart": {
    "config": {
      "changed": false,
      "title": "Ribbon Chart",
      "navSection": "cart",
      "icon": "ribbonChart",
      "image": "ribbonChart.png"
    },
    "items": {
      "general": {
        "responsive": false
      },
      "legend": {
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#252423",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "categoryAxis": {
        "show": true,
        "labelColor": "#252423",
        "fontSize": 14,
        "fontFamily": "Segoe UI",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "innerPadding": 22,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": "#252423",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      },
      "zoom": {
        "show": false,
        "showOnCategoryAxis": true,
        "showOnValueAxis": true,
        "showLabels": false,
        "showTooltip": false
      },
      "dataPoint": {
        "transparency": null,
        "showAllDataPoints": false,
        "fill": "#448822"
      },
      "labels": {
        "show": true,
        "color": "#EEEEEE",
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "labelOrientation": "vertical",
        "labelPosition": "InsideEnd",
        "fontSize": 11,
        "fontFamily": "Segoe UI",
        "enableBackground": true,
        "backgroundColor": "#ffffff",
        "backgroundTransparency": 30
      },
      "plotArea": {
        "transparency": 20
      },
      "ribbonChart": {
        "colorBands": true,
        "bandsTransparency": 20,
        "showBorder": true
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "stackedAreaChart": {
    "config": {
      "changed": false,
      "title": "Stacked Area Chart",
      "navSection": "cart",
      "icon": "stackedAreaChart",
      "image": "stackedAreaChart.png"
    },
    "items": {
      "general": {
        "responsive": false
      },
      "legend": {
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "labelColor": "#252423",
        "fontFamily": "Segoe UI",
        "fontSize": 10,
        "legendMarkerRendering": "markerOnly",
        "matchLineColor": false
      },
      "categoryAxis": {
        "show": true,
        "axisType": "categorical",
        "labelColor": "#252423",
        "fontSize": 14,
        "fontFamily": "Segoe UI",
        "preferredCategoryWidth": 30,
        "maxMarginFactor": 28,
        "concatenateLabels": true,
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "titleColor": "#252423",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "Segoe UI"
      },
      "valueAxis": {
        "show": true,
        "position": "Right",
        "axisScale": "Linear",
        "start": 0,
        "end": 10,
        "labelColor": "#252423",
        "fontSize": 14,
        "fontFamily": "Segoe UI",
        "labelDisplayUnits": "0",
        "labelPrecision": "Auto",
        "showAxisTitle": true,
        "axisStyle": "showTitleOnly",
        "color": "01B8AA",
        "titleText": "",
        "titleFontSize": 12,
        "titleFontFamily": "Courier New",
        "gridlineShow": true,
        "gridlineColor": "#252423",
        "gridlineThickness": 2,
        "gridlineStyle": "dashed"
      },
      "zoom": {
        "show": false,
        "showOnCategoryAxis": true,
        "showOnValueAxis": true,
        "showLabels": false,
        "showTooltip": false
      },
      "dataPoint": {
        "transparency": null,
        "showAllDataPoints": false,
        "fill": "#448822"
      },
      "labels": {
        "show": true,
        "color": "#EEEEEE",
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "fontSize": 11,
        "fontFamily": "Segoe UI",
        "enableBackground": true,
        "backgroundColor": "#ffffff",
        "backgroundTransparency": 30
      },
      "totals": {
        "show": false,
        "color": "#605E5C",
        "labelPrecision": 0,
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "enableBackground": false,
        "backgroundColor": "#252423",
        "backgroundTransparency": 90,
        "showPositiveAndNegative": false
      },
      "lineStyles": {
        "strokeWidth": 4,
        "strokeLineJoin": "bevel",
        "lineStyle": "dashed",
        "showMarker": true,
        "markerShape": "triangle",
        "markerSize": 10,
        "markerColor": "#448822",
        "showSeries": true
      },
      "plotArea": {
        "transparency": 20
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  }
}